var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input",attrs:{"type":"text","readonly":true,"placeholder":_vm._f("translate")(_vm.placeholder)},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.onDateChange($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }